"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastAttributeNameRegex = exports.createMarker = exports.isTemplatePartActive = exports.Template = exports.boundAttributeSuffix = exports.markerRegex = exports.nodeMarker = exports.marker = void 0;
exports.marker = `{{lit-${String(Math.random()).slice(2)}}}`;
exports.nodeMarker = `<!--${exports.marker}-->`;
exports.markerRegex = new RegExp(`${exports.marker}|${exports.nodeMarker}`);
exports.boundAttributeSuffix = '$lit$';
class Template {
    constructor(result, element) {
        this.parts = [];
        this.element = element;
        const nodesToRemove = [];
        const stack = [];
        const walker = document.createTreeWalker(element.content, 133, null, false);
        let lastPartIndex = 0;
        let index = -1;
        let partIndex = 0;
        const { strings, values: { length } } = result;
        while (partIndex < length) {
            const node = walker.nextNode();
            if (node === null) {
                walker.currentNode = stack.pop();
                continue;
            }
            index++;
            if (node.nodeType === 1) {
                if (node.hasAttributes()) {
                    const attributes = node.attributes;
                    const { length } = attributes;
                    let count = 0;
                    for (let i = 0; i < length; i++) {
                        if (endsWith(attributes[i].name, exports.boundAttributeSuffix)) {
                            count++;
                        }
                    }
                    while (count-- > 0) {
                        const stringForPart = strings[partIndex];
                        const name = exports.lastAttributeNameRegex.exec(stringForPart)[2];
                        const attributeLookupName = name.toLowerCase() + exports.boundAttributeSuffix;
                        const attributeValue = node.getAttribute(attributeLookupName);
                        node.removeAttribute(attributeLookupName);
                        const statics = attributeValue.split(exports.markerRegex);
                        this.parts.push({ type: 'attribute', index, name, strings: statics });
                        partIndex += statics.length - 1;
                    }
                }
                if (node.tagName === 'TEMPLATE') {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
            }
            else if (node.nodeType === 3) {
                const data = node.data;
                if (data.indexOf(exports.marker) >= 0) {
                    const parent = node.parentNode;
                    const strings = data.split(exports.markerRegex);
                    const lastIndex = strings.length - 1;
                    for (let i = 0; i < lastIndex; i++) {
                        let insert;
                        let s = strings[i];
                        if (s === '') {
                            insert = (0, exports.createMarker)();
                        }
                        else {
                            const match = exports.lastAttributeNameRegex.exec(s);
                            if (match !== null && endsWith(match[2], exports.boundAttributeSuffix)) {
                                s = s.slice(0, match.index) + match[1] +
                                    match[2].slice(0, -exports.boundAttributeSuffix.length) + match[3];
                            }
                            insert = document.createTextNode(s);
                        }
                        parent.insertBefore(insert, node);
                        this.parts.push({ type: 'node', index: ++index });
                    }
                    if (strings[lastIndex] === '') {
                        parent.insertBefore((0, exports.createMarker)(), node);
                        nodesToRemove.push(node);
                    }
                    else {
                        node.data = strings[lastIndex];
                    }
                    partIndex += lastIndex;
                }
            }
            else if (node.nodeType === 8) {
                if (node.data === exports.marker) {
                    const parent = node.parentNode;
                    if (node.previousSibling === null || index === lastPartIndex) {
                        index++;
                        parent.insertBefore((0, exports.createMarker)(), node);
                    }
                    lastPartIndex = index;
                    this.parts.push({ type: 'node', index });
                    if (node.nextSibling === null) {
                        node.data = '';
                    }
                    else {
                        nodesToRemove.push(node);
                        index--;
                    }
                    partIndex++;
                }
                else {
                    let i = -1;
                    while ((i = node.data.indexOf(exports.marker, i + 1)) !== -1) {
                        this.parts.push({ type: 'node', index: -1 });
                        partIndex++;
                    }
                }
            }
        }
        for (const n of nodesToRemove) {
            n.parentNode.removeChild(n);
        }
    }
}
exports.Template = Template;
const endsWith = (str, suffix) => {
    const index = str.length - suffix.length;
    return index >= 0 && str.slice(index) === suffix;
};
const isTemplatePartActive = (part) => part.index !== -1;
exports.isTemplatePartActive = isTemplatePartActive;
const createMarker = () => document.createComment('');
exports.createMarker = createMarker;
exports.lastAttributeNameRegex = /([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;
